var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrinkHot = function SvgDrinkHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m16.6 15.4 2.91-2.037a2.55 2.55 0 0 0 1.09-2.093 1.916 1.916 0 0 0-2.153-1.9l-2.095.264m0 0A2 2 0 0 0 14.6 8.6h-12a2 2 0 0 0-2 2v4a6 6 0 0 0 6 6h4a6 6 0 0 0 6-6v-4c0-.35-.09-.68-.248-.966M3.6 4.6l.034-.014c.594-.256.874-.988.617-1.617l-.302-.737c-.257-.63.023-1.362.617-1.617L4.6.6m3.5 4 .034-.014c.594-.256.874-.988.617-1.617l-.302-.737c-.257-.63.023-1.362.617-1.617L9.1.6m3.5 4 .034-.014c.594-.256.874-.988.617-1.617l-.302-.737c-.257-.63.023-1.362.617-1.617L13.6.6"
  })));
};
export default SvgDrinkHot;